/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */
const trackingUtils = require('../utils/tracking.utils');
const {trackClickEvent} = require('od-modules/track_events/track.frontevents.utils');

function loadTrackingEvent() {
    var label = this.model.get('trackingLabel') || 'page_selected_' + this.model.get('pageToLoad');

    trackingUtils.trackEvent('results_list_hotels', label, Odigeo.History.getPageNameFromFragment());
}

function updateGrammaticalNumber(numResults) {
    var isSingular = numResults === 1;

    this.$cachedSelectors.singular.toggleClass('hidden', !isSingular);
    this.$cachedSelectors.plural.toggleClass('hidden', isSingular);
}

function updateNumberOfResults() {
    var numResults = this.model.get('numberOfResults');

    this.$cachedSelectors.numResultsContainer.text(numResults);
    updateGrammaticalNumber.call(this, numResults);
}

function updatePagination() {
    const fromTo = this.model.getFromToObject();

    this.$cachedSelectors.paginationContainer
        .toggle(this.model.hasMoreThanOnePage())
        .trigger('repaintPagination', [this.model.get('pageToLoad'), this.model.get('totalPages')]);
    Odigeo.Session.set('fromTo', JSON.stringify(fromTo));
    Odigeo.trigger(this.widget.id + ':newPageRequested', fromTo);
}

function updateSelectedPage(offset) {
    this.model.set('trackingLabel', offset === 1 ? 'page_selected_next' : 'page_selected_previous');
    this.model.set('pageToLoad', this.model.get('pageToLoad') + offset);
    updatePagination.call(this);
}

function updateView() {
    updateNumberOfResults.call(this);
    updatePagination.call(this);
}

module.exports = Odigeo.View.extend({
    selectors: {
        'paginationContainer': '.pagination',
        'paginationGeneralContainer': '.pagination_container',
        'numResultsContainer': '.number_of_results',
        'plural': '.plural',
        'singular': '.singular',
    },

    init: function() {
        this.listenTo(this.model, 'newResults', Odigeo._.bind(updateView, this));
        this.$cachedSelectors.paginationContainer.attr('data-pagination-type', this.widget.options.paginationType);
    },

    initPagination: function() {
        Odigeo.UIElements.enhancePagination(this.$el.find('.pagination'), {
            maxnumberOfResultPagesShown: this.model.get('paginationMaxPageSet'),
            nextCallback: Odigeo._.bind(updateSelectedPage, this, 1),
            previousCallback: Odigeo._.bind(updateSelectedPage, this, -1),
            loadPageCallback: Odigeo._.bind(this.loadSelectedPage, this),
            loadTrackingCallback: Odigeo._.bind(loadTrackingEvent, this),
            allowPrismaResponsiveSpaceHorizontal: false,
        });
        this.$el.find('.pagination').on('paginate', trackClickEvent);
    },

    loadSelectedPage: function(selectedPage) {
        this.model.set('trackingLabel', 'page_selected_' + selectedPage);
        this.model.set('pageToLoad', selectedPage);
        updatePagination.call(this);
        Odigeo.trigger(this.widget.id + ':onAccommodationNewPage', selectedPage);
        Odigeo.SessionScope.gpt.page = selectedPage;
    },

    showContainer: function() {
        this.$el.find(this.selectors.paginationGeneralContainer).removeClass('odf-hidden');
    },

    hideContainer: function() {
        this.$el.find(this.selectors.paginationGeneralContainer).addClass('odf-hidden');
    },
});
